import AdminAppContainer from "./AdminAppContainer";

export default AdminAppContainer;
